angular.module('psModule')
    .directive('footer', function() {
        return {
            template:'<div class="col-md-12 text-center"><p class="footer-info text-muted"><small translate="ps_footer_questions_or_info"></small> <small class="text-lowercase"><a href="mailto:support@maxm.se" translate="ps_support"></a></small></p><p ng-if="version" class="footer-info"><small class="text-muted">{{version}}</small></p><p ng-if="!version" class="footer-info text-muted"><small>&copy; Max Matthiessen</small></p></div>'
        };
    });
